

import React from 'react';
import user1 from '../../../img/doctor.png';
import imageUrl from '../../../img/profilebg.jpg';
import { Tab, Tabs } from 'material-ui/Tabs';
import { getMasterData, getStaffProfileDetails } from '../actions/UserActions';
import { base64Encode, extractDataFromArray, showFormatedDate, base64Decode } from '../../../actions/utilAction';
import { connect } from 'react-redux';
import { CommonButton } from '../../../components/buttons';
import history from '../../../history';
import DocumentList from '../component/staffDocuments/documentList';
// import ApplyLeave from '../component/staffLeave/applyLeave';
// import UserTimeSheet from '../component/userTimeSheet/index';
import { Scrollbars } from 'react-custom-scrollbars';


const style = {
  backgroundImage: 'url(' + imageUrl + ')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
};

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staffId:  props.match.params.id ? base64Decode(props.match.params.id) : null,
      encryptedStaffId: props.match.params.id ? props.match.params.id : null,
      value: 1,
      slideIndex: null,
      genderName: '',
      phoneNumber: '',
      email: '',
      address: '',
      profilePicture: '',
      activeTab: 0,
    };
    this.handleEditUser = this.handleEditUser.bind(this);
  }
  componentWillMount() {
    //let staffId = this.props.loginUserId;
    this.props.getStaffProfileDetails(this.state.staffId);
  };
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.handleUserTabChange('0');
      this.setState({ staffId: nextProps.match.params.id ? base64Decode(nextProps.match.params.id) : null });
    }

    if (nextProps && nextProps.user && this.props.user !== nextProps.user) {
      let genderName = '';
      let genderNameObj = extractDataFromArray(nextProps.master_data.masterGender, nextProps.user.gender);
      if (genderNameObj) {
        genderName = genderNameObj.value;
      }
      let phoneNumber = nextProps.user.phoneNumber;
      let email = nextProps.user.email;
      let address = nextProps.user.address;
      let profilePicture = nextProps.user.photoThumbnailPath;
      this.setState({
        genderName: genderName,
        phoneNumber: phoneNumber,
        email: email,
        address: address,
        profilePicture: profilePicture,
      });
    }
  }

  handleOpen = () => {
    this.setState({ openImage: true });
  };

  handleEditUser() {
    //let encodeUserId = base64Encode((this.props.loginUserId || '').toString());
    history.push(`/user/${this.state.encryptedStaffId}`);
  }

  setActive(tabValue) {
    this.setState({ activeTab: tabValue });
  }

  renderCustomFields = () => {
    if (!this.props.masterUserCustomFields || this.props.masterUserCustomFields.length === 0) {

      return (
        <div className="col-sm-12 history_card mt20">
          <div className="text-center no-record">No Record found.</div>
        </div>
      );
    }
    return (
      <div className="row">
        { this.props.masterUserCustomFields.map((customLabel, index) => {
          return (
            <div className="col-sm-4">
              <div className="form-group">
                <label>{customLabel.customLabelName}</label>
                <p>{this.props.userCustomFields && this.props.userCustomFields[index] && this.props.userCustomFields[index].customLabelValue ? this.props.userCustomFields[index].customLabelValue : ''}</p>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  renderLocations = (staffLocations) => {
    staffLocations = staffLocations || [];
    if (!staffLocations.length) {
      return (
        <div className="col-sm-12 history_card mt20">
          <div className="text-center no-record">No Record found.</div>
        </div>
      );
    }
    return (
      <Scrollbars>
        { staffLocations.map((locObj, index) => {
          let stateName = locObj.stateName ? <small>({locObj.stateName})</small> : null;
          return (
            <div key={index}>
              <p>
                <i className="fa fa-map-marker" aria-hidden="true"></i> {locObj.locationName} {stateName}</p>
              <ul>
                <li>{locObj.locationFullAddress || '-'}</li>
                {/* <li>{`${locationNameObj.city}, `}</li>
                <li>Beth Israel Deaconess Medical Center,</li>
                <li>Tufts Medical Center</li> */}
              </ul>
            </div>);
        })}
      </Scrollbars>);
  };
  renderTags = (staffTags) => {
    staffTags = staffTags || [];
    if (!staffTags.length) {
      return (
        <ul className="tags">
          <li className="tag">No tags found.</li>
        </ul>
      );
    }
    return (
      <ul className="tags">
        { staffTags.map((tagObj, index) => {
          return (
            <li key={index}>
              <span className="tagafter" style={{ backgroundColor: tagObj.colorCode }}>
              </span>
              <span className="tag" style={{ backgroundColor: tagObj.colorCode, color: tagObj.fontColorCode }}>{tagObj.tag || '-'}</span>
            </li>
          );
        })}
      </ul>);
  }
  handleChange = (event, index, value) => this.setState({ value });
  render() {
    var styles = {
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: '#089ccd',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.active_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);

    const {
      staffId,
      firstName,
      middleName,
      lastName,
      doj,
      email,
      degreeName,
      phoneNumber,
      staffFullAddress,
      photoThumbnailPath,
      gender,
      npiNumber,
      userId,
      staffTags,
      staffLocations,
      assignedClient,
    } = this.props.staffProfileDetails || {};
    let fullName = `${firstName || ''} ${middleName || ''} ${lastName || ''}`;
    let name = firstName + ' ' +  lastName;
    let fullAddress = `${staffFullAddress || ''}`;
    return (
      <div>
        <h2 className="page_title">My Profile</h2>
        {this.props.updatePermission ?
        <div className="top-btns">
          <CommonButton className="smbtn" primary={true} onTouchTap={this.handleEditUser} label="Edit"/>
        </div>:null}
        <div className="clearfix"></div>
        <div className="row">
          <div className="col-sm-7">
            <div className="readmin-panel crop">
              <div className="panel-body pd15">
                <div className="profilebg fmngfjgfj" style={style}>
                  {/* <div className="clientpic"><img src={photoThumbnailPath || user1} alt="" /></div> */}
                  <div className="clientpic">
                    {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name.toUpperCase()}</span>) : ''}
                  </div>
                </div>
                <h2 className="ppname">{fullName || ''}{degreeName && `, ${degreeName}`}</h2>
                <div className="ppdetail client_detail">
                  <div className="ledtdiv">
                    {/* <p><b>Specialist :</b> <span>-</span></p> */}
                    <p><b>Gender : </b><span>{gender || '-'}</span></p>
                    <p><b>Date of joining :</b> <span>{doj ? showFormatedDate(doj) : '-'}</span></p>
                    <p><b>NPI number : </b><span>{npiNumber || '-'}</span></p>
                  </div>
                </div>
                <div className="clearfix"></div>
                <address>
                  <div className="client_detail user-d">
                    <p><b>Phone : </b><span>{phoneNumber || '-'}</span></p>
                    <p><b>Email : </b><span>{email || '-'}</span></p>
                    <p><b>Address : </b><span>{fullAddress || '-'}</span></p>
                  </div>
                </address>
              </div>
            </div>
          </div>
          <div className="col-sm-5">
            <div className="row">
              <div className="col-sm-12">
                <div className="readmin-panel crop vitalbox">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Tags</p>
                    </div>
                    <div className="quicksubmenu tagbox">
                      {this.renderTags(staffTags)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Assigned Locations</p>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 assign-loc" style={{ height: '125px' }}>
                        {this.renderLocations(staffLocations)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Assigned Client</p>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        {assignedClient}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 mt-30">
            <div className="readmin-panel">
              <div className="panel-body pd15">
                <Tabs className="tabbox">                
                  {this.props.uploadPermission || this.props.downloadPermission || this.props.deletePermission ?
                    <Tab className="customtab" style={styles.tab[0]} onClick={(e) => this.setActive(0)} value="0" icon={<span className="material-icons">description</span>} label={<font>Documents</font>}>
                      {(this.state.activeTab === 0 && userId)
                        && (<DocumentList staffId = {this.state.encryptedStaffId} userID={userId} isRedirectFromUserProfile={true} />)}
                    </Tab>:null}

               {/*<Tab className="customtab" style={styles.tab[1]} onClick={(e) => this.setActive(1)} value="3" icon={<span className="material-icons">flight_takeoff</span>} label={<font>Leaves</font>}>
                    {(this.state.activeTab === 1 && staffId)
                      && (<ApplyLeave staffId={staffId} isRedirectFromUserProfile={true} />)}
                  </Tab>

                  <Tab className="customtab" style={styles.tab[2]} onClick={(e) => this.setActive(2)} value="4" icon={<span className="material-icons">alarm</span>} label={<font>Time Sheet</font>}>
                    {(this.state.activeTab === 2 && staffId)
                  && (<UserTimeSheet staffId={staffId} isRedirectFromUserProfile={true} />)}
                  </Tab>*/}
                </Tabs> 
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {

 // Start For Role Permission
 let userActionPermission = [];
 let userActionPermissionDocumentList = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'USER');
   let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'USER_PROFILE' && obj.moduleId === userModulePermission[0].moduleId);
   userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);


   let userScreenPermissionDocumentList = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'USER_DOCUMENT_LIST' && obj.moduleId === userModulePermission[0].moduleId);
   userActionPermissionDocumentList = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermissionDocumentList[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

 let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_PROFILE_UPDATE')[0].permission : false;


  let uploadPermission = hasDefaultAccess ? true : userActionPermissionDocumentList ? userActionPermissionDocumentList.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_UPLOAD')[0].permission : false;
  let downloadPermission = hasDefaultAccess ? true : userActionPermissionDocumentList ? userActionPermissionDocumentList.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_DOWNLOAD')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermissionDocumentList ? userActionPermissionDocumentList.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_DELETE')[0].permission : false;

 // End For Role Permission

  return {
    loginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    staffProfileDetails: state.user.staffProfileDetails && state.user.staffProfileDetails.data,
    master_data: state.user.master_data,
    loading: state.user.loading,
    masterUserCustomFields: state.user.master_data && state.user.master_data.masterCustomLabelStaff ? state.user.master_data.masterCustomLabelStaff : [],
    userCustomFields: state.user.get_custom ? state.user.get_custom : [],
    userAssignedLocations: state.user.activeUser && state.user.activeUser.staffLocation ? state.user.activeUser.staffLocation : [],
    updatePermission: updatePermission,
    uploadPermission: uploadPermission,
    downloadPermission: downloadPermission,
    deletePermission: deletePermission,
  };
}
export default connect(mapStateToProps, { getMasterData, getStaffProfileDetails })(UserProfile);



// WEBPACK FOOTER //
// ./src/modules/users/User/userProfile.js